import { type UserRole } from './interfaces';

export const getBadgeFromRoles = (
  roles: UserRole[] = []
): 'starter' | 'starter_239' | 'booster' | 'teambooster' | 'pro' | 'superadmin' | 'none' | 'free' | 'aspiring' => {
  if (roles.includes('superadmin')) return 'superadmin';
  if (roles.includes('pro') || roles.includes('ultim')) return 'pro';
  if (roles.includes('teambooster') || roles.includes('vip')) return 'teambooster';
  if (roles.includes('booster') || roles.includes('plus')) return 'booster';
  if (roles.includes('member') && roles.includes('aspiring') && roles.includes('free')) return 'free';
  if (roles.includes('member') && roles.includes('aspiring')) return 'starter';
  if (roles.includes('aspiring') && roles.length === 1) return 'aspiring';
  if (roles.includes('member') && roles.filter((role) => ['earlyadopter', 'topmember'].includes(role)).length === 1) return 'free';

  return 'none';
};
